<mat-form-field class="country-form w-100" *transloco="let t">
  <mat-label>{{ t('Country') }}</mat-label>
  <mat-select
    #countrySelect
    required
    [compareWith]="helper.codeMatcher"
    [formControl]="countryControl"
    data-cy="country-select">
    @for (country of userConfigsFacade.superAdminCountriesSignal(); track country) {
      <mat-option [value]="country"
        data-cy="country-option">
        {{ t(country.name) }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
